import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiEye, FiEyeOff } from "react-icons/fi";
import { useAuth } from '../context/AuthContext';
import './AuthPages.css';

const AdminLogin = () => {
  const [formData, setFormData] = useState({ username: '', password: '', adminCode: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showAdminCode, setShowAdminCode] = useState(false);

  const { login, currentUser } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (currentUser) {
      if (currentUser.role === 'ADMIN') navigate('/admin');
      else navigate('/dashboard');
    }
  }, [currentUser, navigate]);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSubmitted(true);
    const result = await login(formData.username, formData.password, 'ADMIN', formData.adminCode);
    if (!result.success) setError(result.error);
    setLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-logo-text">
            <img src="/images/clickpay_logo.png" alt="ClickPay - Secure Payment Gateway" className="auth-logo" />
          </div>
          <h1>Admin Login</h1>
          <p>System administration access</p>
        </div>

        {error && (
          <div id="login-error" className="alert alert-danger" role="alert" aria-live="assertive">{error}</div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="username">Admin Username</label>
            <input type="text" id="username" name="username" className="form-control"
              value={formData.username} onChange={handleChange}
              placeholder="Enter admin username" required aria-required="true"
              aria-invalid={submitted && !!error}
              aria-describedby={submitted && error ? 'login-error' : undefined} />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            
            <div className="password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              id="password" name="password" className="form-control"
              value={formData.password} 
              onChange={handleChange}
              onPaste={(e) => e.preventDefault()}
              onCopy={(e) => e.preventDefault()}
              onCut={(e) => e.preventDefault()}
              required
              placeholder="Enter admin password" 
              aria-required="true"
              aria-invalid={submitted && !!error}
              aria-describedby={submitted && error ? 'login-error' : undefined} />
          <span onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <FiEye size={18} /> : <FiEyeOff size={18} />}
          </span>
         </div>
          </div>
          <div className="form-group">
            <label htmlFor="adminCode">Admin Access Code</label>
            <div className="password-wrapper">
            <input 
            type={showAdminCode ? "text" : "password"} 
            id="adminCode" name="adminCode" className="form-control"
              value={formData.adminCode} onChange={handleChange}
              onPaste={(e) => e.preventDefault()}
              onCopy={(e) => e.preventDefault()}
              onCut={(e) => e.preventDefault()}
              required
              placeholder="Enter admin access code" 
              aria-required="true"
              aria-invalid={submitted && !!error}
              aria-describedby={submitted && error ? 'login-error' : undefined} />
            
            <span onClick={() => setShowAdminCode(!showAdminCode)}>
               {showAdminCode ? <FiEye size={18} /> : <FiEyeOff size={18} />}
            </span>
            </div>
            
            <small className="form-text">Additional security code required for admin access</small>
          </div>
          <button type="submit" className="btn btn-primary btn-full admin-btn" disabled={loading}
            aria-busy={loading}>
            {loading ? 'Verifying...' : 'Admin Login'}
          </button>
        </form>

        <div className="auth-links">
          <p>Need an admin account? <Link to="/secure-admin-portal/signup">Register here</Link></p>
        </div>
        <div className="security-notice">
          <i className="fas fa-shield-alt"></i>
          <p>This is a secure admin portal. All access attempts are logged and monitored.</p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
